module.exports = __webpack_public_path__ + "img/telephone.7ebef0ea.svg";